<template>
    <div class="wrap talk">
        <header>
            <h1><a href="#" class="logo"></a></h1>
        </header>
        <div class="container">
            <main class="content">
                <article class="certification">
                    <section class="txt agree-bg">
                    </section>
                    <section>
                        <div class="box row row_c row_jsc">
                            <span><i class="xi-check"></i></span>
                            <p>기부신청이 완료 되었습니다.</p>
                        </div>
                    </section>
                    <section class="mar_b20">
                        <div class="con-box">
                            <h2>기부 신청 제품</h2>
                            <div v-if="searchedData.product.mobile === true" class="item row row_jsb">
                                <span class="item-tit">휴대폰 종류</span>
                                <span class="item-con taR">{{ searchedData.product.modlNm }}</span>
                            </div>
                            <div v-else class="item row row_jsb">
                                <span class="item-tit">종류</span>
                                <span class="item-con taR">{{ searchedData.product.cate01Nm }}</span>
                            </div>
                            <div class="item row row_jsb bg">
                                <span class="item-tit">예상 기부 금액</span>
                                <span class="item-con en taR">{{ searchedData.dntnAmt | currency }}</span>
                            </div>
                        </div>
                        <div class="con-box">
                            <h2>기부자</h2>
                            <div class="item row row_jsb">
                                <span class="item-tit">이름</span>
                                <span class="item-con taR">{{ searchedData.donate.dntnCstmNm }}</span>
                            </div>
                            <div class="item row row_jsb">
                                <span class="item-tit">주민번호</span>
                                <span class="item-con taR">{{ searchedData.donate.dntnCstmIdntNum | account }}</span>
                            </div>
                            <div class="item row row_jsb">
                                <span class="item-tit">주소</span>
                                <span class="item-con taR">{{ searchedData.donate.dntnCstmAddr }}</span>
                            </div>
                        </div>
                    </section>
                </article>
                <div class="cs-center row row_ac row_jsc">
                    <span class="qa">고객센터 문의 </span>
                    <span><a href="tel:1877-5446" class="en phone">1877-5446</a></span>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'

export default {
  name: 'DonateComplete',
  components: {},
  data () {
    return {
      searchData: {
        ordNum: this.$route.query.ordNum || ''
      },
      searchedData: {
        ordNum: '',
        prchNum: 0,
        prchAmt: 0,
        jdgmAmt: 0,
        partDntnAmt: 0,
        dntnAmt: 0,
        product: {
          pgrpCd: '',
          modlNum: 0,
          modlNm: '',
          cate01Num: 0,
          cate01Nm: '',
          mobile: false
        },
        donate: {
          ordNum: '',
          dntnCstmNm: '',
          dntnCstmIdntNum: '',
          dntnCstmAddr: '',
          agrees: []
        }
      }
    }
  },
  watch: {},
  filters: {
    currency (amt) {
      return String(amt).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    account (string) {
      return string.replace(/(\d{6})(.{7})/g, '$1-$2')
    }
  },
  methods: {
    async init () {
      this.search()
    },
    async search () {
      if (!this.searchData.ordNum) {
        this.$Alert.alert('주문번호가 존재하지 않습니다.')
        // TODO 주문번호 없는 경우 처리
        return
      }
      Vue.httpClient
        .get(`/api/purchase/public/donate/complete/${this.searchData.ordNum}`, {})
        .then(response => {
          if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            Object.assign(this.searchedData, response.data.result)
          }
        }).catch(error => {
          console.error('error ::', error)
          this.$Alert.alert('조회시 오류가 발생하였습니다.')
        })
    }
  },
  async mounted () {
    this.init()
    await this.$nextTick()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/purchase/DonateComplete.vue